import { NavLink } from 'react-router-dom'
import { Home, History, BookOpen } from 'lucide-react'

const menuItems = [
  { to: '/moja-biblioteka', label: 'Strona główna', icon: Home, exact: true },
  { to: '/moja-biblioteka/historia', label: 'Historia', icon: History },
  { to: '/moja-biblioteka/subskrypcje', label: 'Subskrypcje', icon: BookOpen },
]

/**
 * Menu pill for the Moja Biblioteka area.
 *
 * Aligned to the left edge of the right-hand content column on desktop.
 */
export default function LibraryMenu({ unreadCounts = {} }) {
  return (
    <nav
      aria-label="Moja Biblioteka"
      className="bg-[var(--library-card-bg)] backdrop-blur-md rounded-full px-2 py-2 shadow-lg border border-[var(--library-border)]"
    >
      <ul className="flex items-center gap-1 sm:gap-2">
        {menuItems.map((item) => {
          const Icon = item.icon
          const badgeCount = item.badgeKey ? unreadCounts[item.badgeKey] : 0

          return (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.exact}
                className={({ isActive }) =>
                  `relative flex items-center gap-2 px-3 sm:px-5 py-2 rounded-full font-bold text-sm sm:text-base transition ${
                    isActive
                      ? 'bg-brand-blue text-brand-gold'
                      : 'text-brand-blue hover:bg-white/40'
                  }`
                }
              >
                <Icon size={18} aria-hidden="true" />
                <span className="hidden sm:inline">{item.label}</span>
                {badgeCount > 0 && (
                  <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-red-500 border-2 border-[var(--library-card-bg)]" />
                )}
              </NavLink>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
